import { useEffect, useState } from 'react';

const DEV_MODE_KEY = 'bracket-run-dev-mode';

export function useDevMode(): boolean {
  const [isDevMode, setIsDevMode] = useState(() => {
    return sessionStorage.getItem(DEV_MODE_KEY) === 'true';
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('dev') === 'true') {
      sessionStorage.setItem(DEV_MODE_KEY, 'true');
      setIsDevMode(true);
    }
  }, []);

  return isDevMode;
}
